// extracted by mini-css-extract-plugin
module.exports = {"notfound":"NotFound_notfound__d2aq5"};